import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { createSupportTicket } from '../../../../helpers/support-helper';

const CATEGORY_OPTIONS = [
    { value: 'INCIDENT', label: 'Incidente' },
    { value: 'BUG', label: 'Bug' },
    { value: 'QUESTION', label: 'Pregunta' },
    { value: 'FEATURE_REQUEST', label: 'Solicitud de mejora' },
    { value: 'OTHER', label: 'Otro' },
];

const PRIORITY_OPTIONS = [
    { value: 'LOW', label: 'Baja' },
    { value: 'MEDIUM', label: 'Media' },
    { value: 'HIGH', label: 'Alta' },
    { value: 'URGENT', label: 'Urgente' },
];

export const SupportTicketCreateScreen = () => {
    const navigate = useNavigate();
    const { token } = useSelector((state) => state.auth);

    const [isSubmitting, setIsSubmitting] = React.useState(false);
    const [error, setError] = React.useState('');
    const [successMessage, setSuccessMessage] = React.useState('');
    const [form, setForm] = React.useState({
        subject: '',
        description: '',
        category: 'INCIDENT',
        priority: 'MEDIUM',
        attachments: [],
    });

    const handleFormChange = ({ target }) => {
        const { name, value } = target;
        setForm((previous) => ({
            ...previous,
            [name]: value,
        }));
    };

    const handleAttachmentsChange = ({ target }) => {
        const nextFiles = Array.from(target.files || []);
        setForm((previous) => ({
            ...previous,
            attachments: nextFiles,
        }));
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        setError('');
        setSuccessMessage('');

        if (!token || isSubmitting) {
            return;
        }

        const payload = {
            subject: String(form.subject || '').trim(),
            description: String(form.description || '').trim(),
            category: String(form.category || 'INCIDENT').trim().toUpperCase(),
            priority: String(form.priority || 'MEDIUM').trim().toUpperCase(),
            attachments: form.attachments,
        };

        if (!payload.subject || !payload.description) {
            setError('Completa asunto y descripción para crear el ticket de soporte.');
            return;
        }

        setIsSubmitting(true);
        const resp = await createSupportTicket(token, payload);

        if (!resp?.success) {
            setError(resp?.message || 'No se pudo crear el ticket de soporte.');
            setIsSubmitting(false);
            return;
        }

        setSuccessMessage(`Ticket creado correctamente: ${resp?.data?.trackingCode || ''}`.trim());
        setIsSubmitting(false);

        setTimeout(() => {
            navigate('/support');
        }, 600);
    };

    return (
        <div className="row">
            <div className="col-12 col-xl-9 col-xxl-8 mx-auto">
                <div className="card stretch stretch-full card__no-border">
                    <div className="card-body pt-3">
                        <div className="d-flex align-items-center justify-content-between mb-3">
                            <h5 className="fw-bold mb-0">Crear ticket de soporte</h5>
                            <button type="button" className="btn btn-light-brand btn-sm" onClick={() => navigate('/support')}>
                                Volver a soporte
                            </button>
                        </div>

                        <p className="text-muted fs-12 mb-3">
                            Reporta cualquier incidente o duda sobre el software. Los adjuntos de soporte no consumen almacenamiento de tu tenant.
                        </p>

                        {error && <div className="alert alert-danger py-2" role="alert">{error}</div>}
                        {successMessage && <div className="alert alert-success py-2" role="alert">{successMessage}</div>}

                        <form onSubmit={handleSubmit}>
                            <div className="row g-3">
                                <div className="col-md-6">
                                    <label className="form-label fw-semibold">Asunto</label>
                                    <input className="form-control" name="subject" value={form.subject} onChange={handleFormChange} />
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label fw-semibold">Categoría</label>
                                    <select className="form-select form-select-sm" name="category" value={form.category} onChange={handleFormChange}>
                                        {CATEGORY_OPTIONS.map((option) => (
                                            <option key={option.value} value={option.value}>{option.label}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label fw-semibold">Prioridad</label>
                                    <select className="form-select form-select-sm" name="priority" value={form.priority} onChange={handleFormChange}>
                                        {PRIORITY_OPTIONS.map((option) => (
                                            <option key={option.value} value={option.value}>{option.label}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-12">
                                    <label className="form-label fw-semibold">Descripción</label>
                                    <textarea className="form-control" name="description" rows={5} value={form.description} onChange={handleFormChange} />
                                </div>
                                <div className="col-12">
                                    <label className="form-label fw-semibold">Adjuntos (capturas, logs, etc.)</label>
                                    <input type="file" className="form-control" multiple onChange={handleAttachmentsChange} />
                                    {form.attachments.length > 0 && (
                                        <div className="mt-2 text-muted fs-12">
                                            {form.attachments.map((file) => file.name).join(' · ')}
                                        </div>
                                    )}
                                </div>
                            </div>

                            <div className="mt-3 d-flex gap-2">
                                <button type="submit" className="btn btn-primary" disabled={isSubmitting}>
                                    {isSubmitting ? 'Enviando...' : 'Crear ticket'}
                                </button>
                                <button type="button" className="btn btn-light-brand" onClick={() => navigate('/support')}>
                                    Cancelar
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};
